<template>
  <div id="agreements" class="sun">
    <div class="agreements">
      <!--List-->
      <AgreementList class="list"
                     :agreements="terms"
                     v-if="terms && terms.length>=1"></AgreementList>
      <!--Button-->
      <button class="confirm"
              @click="next"
              :disabled="!isCompleteAgreements"
              :class="{'active': isCompleteAgreements}"
              v-if="terms && terms.length>=1">
        계약 완료
      </button>
    </div>
  </div>
</template>

<script>
import AgreementList from './components/AgreementList'
import contractsApi from '@/api/now/contractsApi'
import contractService from '@/service/contract/ContractService'
// import pdf from 'vue-pdf'
// import pdfvuer from 'pdfvuer'

export default {
  name: 'Agreements',
  components: {
    AgreementList,
    // pdf,
    // pdfvuer,
  },
  props: {},
  data: function () {
    return {
      isPending: false,
      terms: [],
      file: null,
      image: null,
    }
  },
  computed: {
    isCompleteAgreements() { // 동의 완료 여부
      let terms = this._.filter(this.terms, 'is_required')
      let isAgreedAll = this._.every(terms, 'is_agreed')
      return isAgreedAll
    },
    isComplete() { // 전체 완료 여부
      return this.isCompleteAgreements
    },
  },
  async created() {
    this.$store.commit('ui/headerTitle', '약관 및 이용 동의')
    await this.getAgreements()
    this.isPending = await contractService.isPending()
    if (!this.isPending) {
      alert('이미 계약이 완료되었습니다.')
      this.$router.push({ name: 'agreements' })
    }
  },
  destroyed() {},
  methods: {
    async getTerms() {
      let { data } = await contractsApi.getTerms()
      let terms = this._.filter(data, function (term) {
        return term.is_generated_by_client === false
      })
      return terms
    },
    async getAgreements() {
      let { data } = await contractsApi.getAgreements()
      let agreements = data
      let terms = await this.getTerms()
      for (let term of terms) {
        let agreement = this._.find(agreements, function (_agreement) {
          return _agreement.term.uuid === term.uuid
        })
        if (agreement) {
          term.is_agreed = agreement.is_agreed
        } else {
          term.is_agreed = false
        }
        this.terms.push(term)
      }
    },
    async next() {
      try {
        for (let term of this.terms) {
          await contractsApi.agreeTerm(term.uuid)
        }
        alert('계약 완료되었습니다.')
        this.$router.push({ name: 'dashboard' })
      } catch (e) {
        alert('잠시 문제가 발생하였습니다.', e)
        this.$router.push({ name: 'dashboard' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  #agreements {
    height: calc(100vh - 60px);

    .agreements {
      width: 100%;
      height: 100%;
      .list {
        position: relative;
        float: left;
        height: calc(100% - 68px);
        padding-bottom: 150px;
        overflow: auto;
      }
    }

    .documents {
      width: 100%;
      height: calc(100% - 68px);
      overflow: auto;
    }

    .confirm {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 100%;
      height: 68px;
      font-size: 22px;
      color: #727d8c;
      font-weight: bold;
      background-color: #e3ecf6;
      z-index: 1000;

      &.active {
        color: white;
        background-color: #1baaf1;
      }
    }
  }
</style>
